export default __webpack_public_path__ + "static/media/logo.366e0dc0.png";